var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 155 47",
    style: {
      enableBackground: "new 0 0 155 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFCE00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.6,18.1 23.1,23.2 28.7,24 24.7,28 25.6,33.6 20.6,30.9 15.6,33.6 16.6,28 12.5,24 18.1,23.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "47.9,14.7 51,21 58,22 52.9,26.9 54.1,33.9 47.9,30.6 41.6,33.9 42.8,26.9 37.8,22 44.8,21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "134.4,18.1 131.9,23.2 126.3,24 130.3,28 129.4,33.6 134.4,30.9 139.4,33.6 138.4,28 142.5,24  136.9,23.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107.1,14.7 104,21 97,22 102.1,26.9 100.9,33.9 107.1,30.6 113.4,33.9 112.2,26.9 117.2,22 110.2,21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "77.5,12.2 81.2,19.6 89.4,20.8 83.4,26.6 84.8,34.8 77.5,30.9 70.2,34.8 71.6,26.6 65.6,20.8  73.8,19.6  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.b10b44b5f0f6b8b11ef030f56b779d9e.svg";
export { ForwardRef as ReactComponent };